import CatalogoService from '@/services/catalogo/catalogo.service'
import types from '@/store/modules/common/mutation-types-core'
const state = () => ({
  catalogos:[]
})
const getters = {
  getCatalogos : state => state.catalogos
}

const actions = {
  async fetchCatalogos({ commit }){
    try{
        let response = await CatalogoService.obtener()

        if(response.data){
            commit(types.SET_CATALOGO,response.data)
        }
    
    }catch(error){
        throw new Error(error.message)
    }
    
  },
  async fetchCatalogoGenerico({ }, data){
    try{
        let url,params = null

        if(typeof data === 'object' && data !== null){
          url = data.url
          params = data.params
        }else{
          url = data
        }
    
        let response = await CatalogoService.getCatalogos(url,params);
        return response
    }catch(error){
        throw new Error(error.message)
    }
  },

}

const mutations = {
  [types.SET_CATALOGO](state,catalogos){
    state.catalogos = catalogos
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}